import { RadioGroup } from '@headlessui/react';
import React from 'react';
import { FormControlProps } from '../FormControl/FormControl';
import InnerToggleButtonGroup from './InnerToggleButtonGroup';
import { ToggleProvider } from '../../context/ToggleGroupContext';

export type ToggleButtonGroupProps = {
  dense?: boolean;
  value?: string;
  column?: boolean;
  onChange: (selected: string | undefined) => void;
} & Omit<FormControlProps, 'as'>;

const ToggleButtonGroup = ({
  disabled,
  dense,
  value,
  onChange,

  ...props
}: ToggleButtonGroupProps) => {
  return (
    <ToggleProvider disabled={disabled} dense={dense}>
      <RadioGroup value={value} onChange={onChange}>
        <InnerToggleButtonGroup {...props} />
      </RadioGroup>
    </ToggleProvider>
  );
};

ToggleButtonGroup.displayName = 'ToggleButtonGroup';
export default ToggleButtonGroup;
